<template>
  <div>
    <WebshopHeader
      :bread-crumbs="[$t('Loyalty.Breadcrumbs.Webshop')]"
      :title="$t('Loyalty.TeaserPage.PageTitle')"
      :description="$t('Loyalty.TeaserPage.PageDescription', { price: toEuros('10') })"
      :is-authenticated="loggedIn"
      :amount="spaazaUser.amount"
      :country="country"
    />
    <div
      v-loading="loading"
      class="product-grid text-gray-600 grid grid-cols-2 md:grid-cols-4 md:border-t border-gray-200 md:pt-5"
    >
      <NuxtLink
        v-for="({ name, price, slug, category }, index) in products"
        :key="`${name}${index}`"
        class="product-grid-item col-span-1 cursor-pointer focus:outline-none flex flex-col"
        :to="$i18n.localePath({ name: 'webshop-category-slug', params: {
          category,
          slug
        } })"
      >
        <OImage
          v-bind="getImagePaths(`/images/frontend/loyalty/products/${slug}/product`)"
          img-class="rounded mb-2"
          :alt="$t('Accessibilty.AltTags.PhotoOfProductWithName', { name: name })"
        />
        <p class="ota-p14 mb-1 text-left" v-text="name" />
        <p class="ota-p18 text-left" v-text="toEuros(price)" />
      </NuxtLink>
    </div>
    <ThumbnailPreview ref="previewModal">
      <OImage
        v-if="clickedProduct"
        v-bind="getImagePaths(`/images/frontend/loyalty/products/${clickedProduct.slug}/product-zoom`)"
        img-class="rounded"
        :alt="$t('Accessibilty.AltTags.PhotoOfProductWithName', { name: name })"
      />
    </ThumbnailPreview>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import WebshopHeader from '@/components/Webshop/WebshopHeader'
import ThumbnailPreview from '@/components/Modals/Webshop/ThumbnailPreview'
import OImage from '@/components/OImage'
import { getImagePaths, addLocalCurrency } from '@/utils/general'
import { SET_REDIRECT_URL } from '@/utils/store/mutationTypes'
import { GET_PRODUCTS_OVERVIEW } from '@/utils/store/actionTypes'

export default {
  name: 'Webshop',
  layout: 'webshop',
  components: { WebshopHeader, OImage, ThumbnailPreview },
  async fetch () {
    await this.getAndSetProductsOverview()
  },
  data () {
    return {
      clickedIndex: 0,
      loading: false,
      products: []
    }
  },
  computed: {
    clickedProduct () {
      return this.products[this.clickedIndex]
    },
    ...mapState('app', {
      country: state => state.country
    }),
    ...mapState('app', {
      locale: state => state.locale
    }),
    ...mapState('auth', {
      loggedIn: state => state.loggedIn
    }),
    ...mapState('spaaza', {
      spaazaUser: state => state
    })
  },
  created () {
    this.setRedirectUrl({ url: '/webshop' })
  },
  methods: {
    toEuros (price = '0') {
      return addLocalCurrency(
        parseFloat(price),
        this.locale + '-' + this.country.toUpperCase(),
        'EUR'
      ).replace(/\s/g, '')
    },
    getImagePaths (path = '') {
      return getImagePaths({ path, extension: '.webp', s3: true })
    },
    async getAndSetProductsOverview () {
      try {
        this.loading = true

        const products = await this.getProductsOverview()
        this.products = products
      } catch (error) {
        this.$ota.general.logError(error)
      } finally {
        this.loading = false
      }
    },
    ...mapMutations('auth', {
      setRedirectUrl: SET_REDIRECT_URL
    }),
    ...mapActions('webshop', {
      getProductsOverview: GET_PRODUCTS_OVERVIEW
    })
  },
  head () {
    return {
      title: this.$t('Loyalty.TeaserPage.SEOTitle')
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-grid {
  @apply mx-auto;
  max-width: 110rem;
  padding-left: 1rem;
  padding-right: 1rem;

  .oimage >>> img {
    max-width: 100% !important;
  }

  .ota-p14 {
    @apply text-sm !important;
  }

  &-item {
    @apply mb-9;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@screen md {
  .product-grid {
    &-item {
      @apply px-5 mb-7;
    }
  }
}
</style>
